import { render } from "./EditTeamMember.vue?vue&type=template&id=27cb04f0"
import script from "./EditTeamMember.vue?vue&type=script&lang=js"
export * from "./EditTeamMember.vue?vue&type=script&lang=js"
script.render = render

export default script